// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  Brand: 'default',
  //  define your api end point here
  apiURL: 'https://paybevdevapi.azurewebsites.net/api/', //dev
  // apiURL: 'https://localhost:7105/api/', //local
};

export const paybevEnvironment = {
  production: false,
  //  define your front end url point here
  URL: 'https://dev.paybev.app/', //dev
};

export const QBOEnvironment = {
  //  define your front end url point here
  URL: 'https://app.sandbox.qbo.intuit.com', //sandbox
};

export const supplierEnvironment = {
  URL: 'https://supplier-dev.paybev.app/',  //dev
};



/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
